import { useEffect } from 'react';
import axios from 'axios';
import { useRequest } from './request';
import { hideWithStars } from '../utils/transformTitle';

export default function useProblemPredReq(
  kcId: string,
  studentId: string,
  date: string,
  predModelVersion: string
) {
  const [state, { run }] = useRequest(async (kcIdToSend: string) => {
    if (kcIdToSend === undefined) {
      return [];
    }
    const problemPredictPromise = axios({
      method: 'get',
      url: `https://prod-kt-rest-api-txfcgt4xfa-du.a.run.app/v2/predict/kc/details/laivdata/plunger/${predModelVersion}/${studentId}/${date}/${kcIdToSend}`,
      headers: { 'X-Application-id': 'com.laivdata.persona.demo' },
    });

    const problemTitlePromise = axios({
      method: 'get',
      url: `https://kms-api-dk.laivdata.com/graph/v2/subgraph/linked/USM_Problem/KC/CONTAINS/${kcIdToSend}`,
      headers: {
        'X-Laiv-API-Key':
          '2739e304158cee4ff57a258d2cae3216d0ef7dc60a1d040bb4f3a5db28b9',
      },
    });

    const [problemPredict, problemTitle] = await Promise.all([
      problemPredictPromise,
      problemTitlePromise,
    ]);
    const kcProblemPredict = (problemPredict?.data?.problem_list || {})[
      kcIdToSend
    ];
    const idToTitle: Map<string, any> = new Map();
    const nodes = problemTitle?.data?.data?.graph?.nodes || [];
    for (const node of nodes) {
      const properties = node.properties;
      properties.title = hideWithStars(properties.title);
      idToTitle.set(properties._uid.toString(), node);
    }

    for (const pr of kcProblemPredict) {
      pr['problemLink'] = idToTitle.get(pr.item_id)?.properties.title.trim();
    }

    return kcProblemPredict;
  });
  useEffect(() => {
    if (date && studentId) {
      run(kcId);
    }
  }, [date, studentId, kcId, run]);
  console.log('useProblemPredReq', state);
  return [state];
}
